import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { type ToastMessage, type ToastSeverity, ToastSeverity as Severity } from '../../shared/ui/molecules/toast/toast.model';

const DEFAULT_LIFE = 4000;

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly translate = inject(TranslateService);
  private _nextId = 0;
  private readonly _messages = signal<ToastMessage[]>([]);

  readonly messages = this._messages.asReadonly();

  success(detail: string, summary?: string, life = DEFAULT_LIFE): void {
    this._add(Severity.SUCCESS, summary ?? this.translate.instant('TOAST.SUCCESS'), detail, life);
  }

  error(detail: string, summary?: string, life = DEFAULT_LIFE): void {
    this._add(Severity.ERROR, summary ?? this.translate.instant('TOAST.ERROR'), detail, life);
  }

  warning(detail: string, summary?: string, life = DEFAULT_LIFE): void {
    this._add(Severity.WARNING, summary ?? this.translate.instant('TOAST.WARNING'), detail, life);
  }

  info(detail: string, summary?: string, life = DEFAULT_LIFE): void {
    this._add(Severity.INFO, summary ?? this.translate.instant('TOAST.INFO'), detail, life);
  }

  dismiss(id: number): void {
    this._messages.update((msgs) => msgs.filter((m) => m.id !== id));
  }

  private _add(severity: ToastSeverity, summary: string, detail: string, life: number): void {
    const id = this._nextId++;
    this._messages.update((msgs) => [...msgs, { id, severity, summary, detail, life }]);
    setTimeout(() => this.dismiss(id), life);
  }
}
